import React, {memo} from "react";
import {Modal, ModalHeader, ModalBody} from "reactstrap";
import PropTypes from "prop-types";
import Loader from "../../components/Loader";
import AddUserForm from "../Forms/AddUserForm";

const AddUser = (props) => {
  const {data, onCancel, open} = props;

  return (
    <Modal unmountOnClose={true} isOpen={open} backdrop={"static"} size={"lg"}>
      <Loader />
      <ModalHeader>{data && data.id ? "Edit User" : "Add User"}</ModalHeader>
      <ModalBody>
        <div className="pl-lg-4">
          <AddUserForm data={data} onCancel={onCancel} />
        </div>
      </ModalBody>
    </Modal>
  );
};

AddUser.propTypes = {
  data: PropTypes.object,
  onCancel: PropTypes.func.isRequired,
  open: PropTypes.bool.isRequired,
};

export default memo(AddUser);
